import { FormControl, Validators } from '@angular/forms';
import { EMAIL_PATTERN, VALIDATION_RULES } from '../../../../common/constants';

export class LoginModel {
  email = '';
  password = '';

  constructor(params?: LoginModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class IdTokenModel {
  idToken: string;
  constructor(params?: IdTokenModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class LoginForm {
  constructor(
    loginModel: LoginModel,
    public email: FormControl<string | null> = new FormControl(loginModel.email, [
      Validators.required,
      Validators.maxLength(VALIDATION_RULES.input.maxLength),
      Validators.pattern(EMAIL_PATTERN),
    ]),
    public password: FormControl<string | null> = new FormControl(loginModel.password, [
      Validators.required,
      Validators.minLength(VALIDATION_RULES.password.minLength),
    ]),
  ) {}
}
